import { formatSendTime } from "./send-window";
import type { ReminderPlan } from "./meeting-reminders";

/** «Kunden får invitasjon nå, e-post onsdag 08:00, SMS torsdag 08:00 og torsdag 08:45» til bookingdialogen. */
export function describeReminderPlan(plan: ReminderPlan): string {
  const email = plan.items.filter((i) => i.channel === "email").map((i) => formatSendTime(i.sendAt));
  const sms = plan.items.filter((i) => i.channel === "sms").map((i) => formatSendTime(i.sendAt));
  const parts = ["Kunden får invitasjon nå"];
  if (email.length) parts.push(`e-post ${email.join(" og ")}`);
  if (sms.length) parts.push(`SMS ${sms.join(" og ")}`);
  return parts.join(", ");
}
